import React from 'react'

import arrowBlue from '../../assets/images/arrow-small-blue.svg'
import LetsTalkCta from '../LetsTalkCta'
import { getEnterpriseAIContent } from '../../constants/enterpriseAIContent'

const EnterpriseAIHero = ({ lang }) => {
  const content = getEnterpriseAIContent(lang)
  const { hero } = content
  const isEn = lang === 'en'

  return (
    <section className="enterprise-ai-hero" aria-labelledby="enterprise-ai-hero-heading">
      <div className="enterprise-ai-hero__card">
        <div className="content container">
          <p className="enterprise-ai-hero__eyebrow">{hero.eyebrow}</p>
          <h1 className="enterprise-ai-hero__title" id="enterprise-ai-hero-heading">
            <span className="enterprise-ai-hero__title-dark">{hero.headlineDark}</span>{' '}
            <span className="enterprise-ai-hero__title-accent">
              {hero.headlineAccentLead} {hero.headlineAccentRest}
            </span>
          </h1>
          <div className="enterprise-ai-hero__ctas">
            <LetsTalkCta
              isEn={isEn}
              hex="#322EFF"
              tone="accent"
              label={hero.ctaPrimary}
              paintDrip
            />
            <a
              href="#enterprise-ai-loop"
              className="lets-talk-cta lets-talk-cta--accent"
            >
              <span className="lets-talk-cta__label">{hero.ctaSecondary}</span>
              <span className="lets-talk-cta__arrow" aria-hidden="true">
                <img src={arrowBlue} alt="" width={15} height={15} decoding="async" />
              </span>
            </a>
          </div>
        </div>
      </div>
    </section>
  )
}

export default EnterpriseAIHero
